export const CheckIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={11} viewBox="0 0 16 11" fill="none">
      <path d="M1.4375 6L5.8125 10.375L14.5625 1" stroke="#514B4D" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
